module.exports = __webpack_public_path__ + "img/private-lesson.bf6a5982.jpg";